import enTranslations from "@/i18n/locales/en/en-translations.json";
import i18n from "i18next";
export function errorKeyFormate(str: string) {
  const enJson = enTranslations as any;
  if (!str) return str;

  const keys = Object.keys(enJson);

  // 1️⃣ Try exact key match
  let match = keys.find((k) => k === str);

  // 2️⃣ Try exact value reverse match
  if (!match) {
    match = keys.find((k) => enJson[k] === str);
  }

  if (!match) {
    const baseText = str.split("{{")[0].trim();
    const inputBase = baseText.toLowerCase();

    const MIN_PREFIX_CHARS = 4;
    const isLooseTranslationPrefixOfMessage = (
      enRaw: string,
      enLower: string
    ): boolean => {
      const hasPrefix =
        enLower.startsWith(inputBase) || inputBase.startsWith(enLower);
      if (!hasPrefix) return false;
      const enTrim = enRaw.trim();

      // Message starts with translation value → guard tiny/single-token labels vs long API text.
      if (inputBase.startsWith(enLower) && inputBase.length > enLower.length) {
        if (enTrim.length < MIN_PREFIX_CHARS) return false;

        const restAfter = inputBase.slice(enLower.length).trimStart();
        if (!enRaw.includes("{{") && restAfter.length >= 5) {
          return false;
        }

        const enIsSingleWord = !/\s/.test(enTrim);

        // "Project" must not truncate "Project & role successfully assigned…"
        if (enIsSingleWord && restAfter.length >= 20) return false;
      }

      // Translation starts with beginning of message (message is shorthand for key)?
      // Reject shaving a sentence down to first few chars of a long string.
      if (enLower.startsWith(inputBase) && enLower.length > inputBase.length) {
        if (inputBase.length < MIN_PREFIX_CHARS && baseText.length > 12) {
          return false;
        }
      }

      return true;
    };

    // 3️⃣ Find keys whose value starts with same base text
    const possibleKeys = keys.filter((k) => {
      if (typeof enJson[k] !== "string") return false;
      const enRaw = enJson[k] as string;
      return isLooseTranslationPrefixOfMessage(enRaw, enRaw.toLowerCase());
    });

    if (possibleKeys.length === 1) {
      match = possibleKeys[0];
    } else if (possibleKeys.length > 1) {
      // 4️⃣ Additional text after placeholder disambiguation
      const afterPlaceholder = str.split("}}")[1]?.trim() || "";

      const refinedMatch = possibleKeys.find((k) => {
        if (typeof enJson[k] === "string") {
          return enJson[k]?.includes(afterPlaceholder);
        }
        return false;
      });

      match = refinedMatch || possibleKeys[0];
    }
  }

  if (!match) {
    return i18n.t(str); // fallback to direct translate
  }

  // ✔ Handle placeholders
  const placeholders = match.match(/{{\s*[\w]+\s*}}/g) || [];
  const values: Record<string, string> = {};

  const inputPlaceholders = str.match(/{{\s*([^}]+)\s*}}/g) || [];

  placeholders.forEach((p, i) => {
    const keyName = p.replace(/{{\s*|\s*}}/g, "").trim();
    if (inputPlaceholders[i]) {
      values[keyName] = inputPlaceholders[i].replace(/{{\s*|\s*}}/g, "").trim();
    }
  });

  return i18n.t(match, values);
}
